module.exports = __webpack_public_path__ + "static/media/loaded_inactive.48cb65de.svg";